const getDefaultApiBaseUrl = () => {
  if (typeof window === "undefined") {
    return "http://localhost:5001";
  }

  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:5001";
  }

  return window.location.origin;
};

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || getDefaultApiBaseUrl();

export default API_BASE_URL;
